import request from "@/utils/request";
import {CfForm, CfQuery, Page, PcForm, PcQuery} from "@/api/priceclass/types";

export const page = (param: PcQuery, page: Page) =>
    request({
        url: "/price-class",
        method: "GET",
        params: {...param, ...page}
    });

export const cfPage = (param: CfQuery, page: Page) =>
    request({
        url: "/coefficient",
        method: "GET",
        params: {...param, ...page}
    });

export const cfDetail = (id: string) =>
    request({
        url: `/coefficient/${id}`,
        method: "GET",
    });

export const create = (data: PcForm) =>
    request({
        url: "/price-class",
        method: "PUT",
        data: data
    });

export const createCf = (data: CfForm) =>
    request({
        url: "/coefficient",
        method: "PUT",
        data: data
    });

export const updateCf = (data: CfForm) =>
    request({
        url: "/coefficient",
        method: "POST",
        data: data
    });


export const changeStatus = (id: string, status: boolean) =>
    request({
        url: "/price-class/status",
        method: "POST",
        data: {id, status}
    });

export const changeCfStatus = (pcId: string, id: string, status: boolean) =>
    request({
        url: "/coefficient/status",
        method: "POST",
        data: {pcId, id, status}
    });


